<template>
    <MainContent :title="$t('parcelas.venta_parcelas')">
        <template v-slot:header>
            <h3 class="card-title pb-3">{{ $t('parcelas.venta_parcelas') }}</h3>
        </template>
        <template v-slot:content>
            <div v-if="!loading">
                <b-container>
                    <ContentOrLoading>
                        <Stepper
                            v-if="!loading"
                            ref="stepper"
                            :steps="steps" 
                        >
                            <template #pasoZona="{ changeStep }">
                                <VentaPasoUno @terminado="zona => { finalizarPasoUno(zona); changeStep(); }" />  
                            </template>
                            <template #pasoParcelas="{ changeStep }">
                                <VentaPasoDos ref="VentaPasoDos" :zona="zona" @terminado="(datos, cart_id) => { rellenarDatosParcelas(datos, cart_id); changeStep(); }" @cambiarZona="() => { cambiarZona(); changeStep(true); }" />
                            </template>
                            <template #pasoRellenarDatos="{ changeStep }">
                                <VentaPasoTres :datosParcelas="datosParcelas" :cart_id="cart_id" @terminado="(datos) => { rellenarDatosCompra(datos); changeStep(); }" @cambiarParcelas="() => { borrarSesion(); changeStep(true); }" />
                            </template>
                            <template #pasoResumenDatos="{ changeStep }">
                                <VentaPasoCuatro :datosParcelas="datosParcelas" :cart_id="cart_id" @terminado="() => { changeStep(); }" @cambiarDatos="() => { changeStep(true); }"  @comenzarDeNuevo="() => { borrarSesion(); cambiarZona(); $refs.stepper.currentStep -= 3; }" @nuevaCompra="() => { $refs.stepper.currentStep -= 3; }"/>
                            </template>
                        </Stepper>
                    </ContentOrLoading>
                </b-container>
            </div>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from "@/components/backend/components/MainContent.vue";
    import VentaPasoUno from '@/components/backend/parcelas/VentaPasoUno';
    import VentaPasoDos from '@/components/backend/parcelas/VentaPasoDos';
    import VentaPasoTres from '@/components/backend/parcelas/VentaPasoTres';
    import VentaPasoCuatro from '@/components/backend/parcelas/VentaPasoCuatro';
    import Stepper from '@/components/frontend/events/compra/components/Stepper';

    export default {
        data() {
            return {
                zona: null,
                loading: false,
                datosParcelas: null,
                cart_id: null,
            }
        },
        methods: {
            finalizarPasoUno(zona) {
                this.zona = zona;
            },
            cambiarZona() {
                this.zona = null;
            },
            rellenarDatosParcelas(datos, cart_id) {
                this.datosParcelas = datos;
                this.cart_id = cart_id;
            },           
            rellenarDatosCompra(datos) {
                this.datosParcelas = datos;
            },           
            borrarSesion() {
                const params = {
                    cart_id: this.cart_id,
                };

                this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params).then(res => {
                    this.cart_id = null;
                    this.datosParcelas = null;
                    this.reloadComponents++;
                }).finally(() => {
                    this.loading = false;
                });
            },

        },
        computed: {
            steps() {
                return [
                    { label: this.$t('parcelas.selecciona_region'), slot: "pasoZona" },
                    { label: this.$t('parcelas.selecciona_parcelas'), slot: "pasoParcelas" },
                    { label: this.$t('parcelas.rellena_datos'), slot: "pasoRellenarDatos" },
                    { label: this.$t('parcelas.resumen_datos'), slot: "pasoResumenDatos" }
                ]
            }
        },
        components: {
            MainContent,VentaPasoUno, VentaPasoDos, VentaPasoTres, VentaPasoCuatro, Stepper
        },
    }
</script>
